import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import {
  PortalOfficialBadge,
  PortalStatusPageShell,
  PortalStatusWordmark,
  PortalTrustFooter,
  elevatedCardClassName,
} from '@/components/layout/portalStatusPage'
import { useAuth } from '@/contexts/AuthContext'

/**
 * Shown when a Firebase account signs in successfully but is not an active risk-assessment user.
 * There is no self-service path; access is provisioned by a Mezza representative.
 */
export function NotAuthorized() {
  const { logout } = useAuth()

  return (
    <PortalStatusPageShell>
      <Card className={elevatedCardClassName}>
        <div className="border-b border-border/30 px-8 pb-5 pt-9 text-center">
          <PortalStatusWordmark />

          <div className="mt-7 space-y-5">
            <PortalOfficialBadge />

            <div className="space-y-2.5">
              <h1 className="text-xl font-semibold tracking-tight text-foreground">
                Access not available
              </h1>
              <p className="text-sm leading-relaxed text-muted-foreground">
                You signed in successfully, ask your Mezza contact to enable access for this
                account
              </p>
            </div>
          </div>
        </div>

        <CardContent className="px-8 pb-8 pt-6">
          <Button
            variant="outline"
            className="h-12 w-full rounded-xl text-base font-semibold"
            onClick={logout}
          >
            Log out
          </Button>
        </CardContent>
      </Card>

      <PortalTrustFooter />
    </PortalStatusPageShell>
  )
}
